module.exports = __webpack_public_path__ + "static/media/tmmnzlLogo.e5bfdb71.png";